import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Loading, ProgressBar } from '@evertrue/et-components';
import get from 'lodash.get';
import ProfileCardHeader from './profile-card-header';
import Helptip from 'components/tooltip/helptip';
import EmptyStateMessage from 'components/lists/empty-state-message';

import { gqlCall } from 'entities/helpers/gqlCall';
import { usePromiseResolver } from '@evertrue/promise-resolver';

const gql = String.raw;
const QUERY = gql`
  query ($id: BigInt!) {
    contact(id: $id) {
      et_score {
        dds_score
      }
    }
  }
`;
const tooltip_text =
  "The Donor Potential Score is a score from 1-100 that indicates the strength of a constituent's giving pattern. It is calculated using gift transaction data, and is calculated nightly for each constituent with gift transaction information.";

const DonorPotentialScoreInfo = ({ id }) => {
  const hasLoadedOnce = useRef(false);
  const [dps, fetching] = usePromiseResolver(() => {
    return gqlCall(QUERY, { id: id }).then((results) => {
      return get(results, 'data.contact.et_score.dds_score', 0);
    });
  }, [id]);

  useEffect(() => {
    if (dps !== undefined && !fetching) {
      hasLoadedOnce.current = true;
    }
  }, [dps, fetching]);

  // Only show loading spinner on refetch (not initial load, since parent shows one)
  const showLoading = fetching && hasLoadedOnce.current;

  return (
    <>
      <ProfileCardHeader className={'donor-potential-score--card-header-small'} title={'Donor Potential Score'}>
        <Helptip help_key="dps" body={tooltip_text} />
      </ProfileCardHeader>
      <div className="donor-potential-score">
        {showLoading ? (
          <Loading position="center" />
        ) : dps !== undefined ? (
          dps > 0 ? (
            <div className="donor-potential-score--score">
              <div className={'donor-potential-score--score-value'}>{dps} out of 100</div>
              <div className={'donor-potential-score--score-bar'}>
                <ProgressBar progressColor={'#a54ab5'} percent={dps} />
              </div>
            </div>
          ) : (
            <EmptyStateMessage hideIcon text="No gift transaction data available for this constituent" />
          )
        ) : null}
      </div>
    </>
  );
};

DonorPotentialScoreInfo.propTypes = {
  id: PropTypes.number,
};

export default DonorPotentialScoreInfo;
